import axios from 'axios';
import qs from 'qs';
import { BASE_SITE } from '../apis';
import { handleSetBackdropLoading } from '../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../redux/actions/snackbar';

/**
 * options:
 *  dispatch, endpoint, method='get', data={}, token=null,
 *  onSuccess, onError, successMessage, showSnackbar=true,
 *  autoLoading=true, isForm=true, signal (AbortSignal)
 */
const apiRequest = async (options = {}) => {
    const {
        dispatch,
        endpoint,
        method = 'get',
        data = {},
        token = null,
        onSuccess = () => {},
        onError = () => {},
        successMessage = null,
        showSnackbar = true,
        autoLoading = true,
        isForm = true,
        signal,
    } = options;

    // reset snackbar
    if (dispatch) dispatch(handleSetOpenCustomSnackbar(false));
    if (autoLoading && dispatch) dispatch(handleSetBackdropLoading(true));

    try {
        const headers = {
            Accept: 'application/json',
            ...(method.toLowerCase() !== 'get' && {
                'Content-Type': isForm ? 'application/x-www-form-urlencoded' : 'application/json',
            }),
            ...(token && { Authorization: token }),
        };

        const axiosConfig = {
            method,
            url: BASE_SITE + endpoint,
            headers,
            signal, // AbortController signal (axios >= 1.x supports this)
        };

        if (method.toLowerCase() === 'get') {
            // use params for GET
            axiosConfig.params = data;
            // if you need custom params serialization, you can add:
            // axiosConfig.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });
        } else {
            axiosConfig.data = isForm ? qs.stringify(data) : data;
        }

        const response = await axios(axiosConfig);
        const res = response && response.data;

        if (res && res.status === 'ok') {
            onSuccess(res);
                if (successMessage && showSnackbar && dispatch) {
                    dispatch(
                        handleSetOpenCustomSnackbar(true, {
                            message: successMessage,
                            severity: 'success',
                            vertical: 'top',
                            horizontal: 'right',
                        })
                    );
                }
                if (res && typeof res.code !== 'undefined' && dispatch) {
                    dispatch(
                        handleSetOpenCustomSnackbar(true, {
                            message: `کد: ${res.code}`,
                            severity: 'warning',
                            vertical: 'top',
                            horizontal: 'center',
                        })
                    );
                }
        } else {
            if (showSnackbar && dispatch) {
                dispatch(
                    handleSetOpenCustomSnackbar(true, {
                        message: (res && res.message) || 'خطا! لطفا مجدد تلاش کنید',
                        severity: 'error',
                        vertical: 'top',
                        horizontal: 'right',
                    })
                );
            }
            onError(res);
        }
    } catch (error) {
        // تشخیص کنسل شدن درخواست (axios v1 -> CanceledError / ERR_CANCELED) یا AbortError
        const isCanceled =
            error &&
            (error.name === 'CanceledError' ||
            error.name === 'AbortError' ||
            error.code === 'ERR_CANCELED' ||
            (typeof error.message === 'string' && error.message.toLowerCase().includes('canceled')));

        if (isCanceled) {
            // نخواهیم نوتیفای کرد یا اسنکبار نشان بدهیم
            console.log('⛔ درخواست کنسل شد');
        } else {
            if (showSnackbar && dispatch) {
                dispatch(
                    handleSetOpenCustomSnackbar(true, {
                        message: 'خطا در ارتباط با سرور. لطفاً مجدداً تلاش کنید.',
                        severity: 'error',
                        vertical: 'top',
                        horizontal: 'right',
                    })
                );
            }
            onError(error);
        }
    } finally {
        if (autoLoading && dispatch) dispatch(handleSetBackdropLoading(false));
    }
};

export default apiRequest;
